module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "padding-bottom": "70px",
      "padding-top": "5px",
      "padding-left": "5px",
      "padding-right": "5px"
    }
  }, [_c('v-container', [_c('download-data', {
    attrs: {
      "timeRange": _vm.timeRange,
      "organizationId": _vm.organizationId,
      "irrigationOrders1": _vm.irrigationOrders1,
      "irrigationOrders2": _vm.irrigationOrders2,
      "equipmentsData1": _vm.equipmentsData1,
      "equipmentsData2": _vm.equipmentsData2
    }
  })], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('h2', {
    staticClass: "display-3 organization-name-title"
  }, [_vm._v("LIAG")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('timeFilter', {
    attrs: {
      "timeRange": _vm.timeRange
    },
    on: {
      "update:timeRange": function($event) {
        _vm.timeRange = $event
      },
      "update:time-range": function($event) {
        _vm.timeRange = $event
      }
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('irrigation-orders-table', {
    attrs: {
      "limit": "7",
      "offset": "0",
      "pageNumber": "1",
      "uniqueIrrigationOrders": _vm.irrigationOrders1,
      "timeRange": _vm.timeRange,
      "organizationId": _vm.organizationId
    },
    on: {
      "update:uniqueIrrigationOrders": function($event) {
        _vm.irrigationOrders1 = $event
      },
      "update:unique-irrigation-orders": function($event) {
        _vm.irrigationOrders1 = $event
      }
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('irrigation-orders-table', {
    attrs: {
      "limit": "7",
      "offset": "7",
      "pageNumber": "2",
      "uniqueIrrigationOrders": _vm.irrigationOrders2,
      "timeRange": _vm.timeRange,
      "organizationId": _vm.organizationId
    },
    on: {
      "update:uniqueIrrigationOrders": function($event) {
        _vm.irrigationOrders2 = $event
      },
      "update:unique-irrigation-orders": function($event) {
        _vm.irrigationOrders2 = $event
      }
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm3": ""
    }
  }, [_c('equipments-table', {
    attrs: {
      "limit": "7",
      "pageNumber": "1",
      "table": "",
      "timeRange": _vm.timeRange,
      "organizationId": _vm.organizationId
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm3": ""
    }
  }, [_c('gruopedBarChart', {
    attrs: {
      "limit": "7",
      "offset": "0",
      "pageNumber": "1",
      "table": "",
      "equipmentsData": _vm.equipmentsData1,
      "timeRange": _vm.timeRange,
      "organizationId": _vm.organizationId
    },
    on: {
      "update:equipmentsData": function($event) {
        _vm.equipmentsData1 = $event
      },
      "update:equipments-data": function($event) {
        _vm.equipmentsData1 = $event
      }
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm3": ""
    }
  }, [_c('equipments-table', {
    attrs: {
      "limit": "7",
      "pageNumber": "2",
      "timeRange": _vm.timeRange,
      "organizationId": _vm.organizationId
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm3": ""
    }
  }, [_c('gruopedBarChart', {
    attrs: {
      "limit": "7",
      "offset": "7",
      "pageNumber": "2",
      "table": "",
      "equipmentsData": _vm.equipmentsData2,
      "timeRange": _vm.timeRange,
      "organizationId": _vm.organizationId
    },
    on: {
      "update:equipmentsData": function($event) {
        _vm.equipmentsData2 = $event
      },
      "update:equipments-data": function($event) {
        _vm.equipmentsData2 = $event
      }
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a1f04e6a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/DashboardLiag.vue
// module id = 1748
// module chunks = 0